import { NavigationItem } from "@/shared/bsm/core/process/components/ui/process-page";
import t from "@/lang/lang";
import {
  CalendarCheck,
  CalendarDays,
  ClipboardCheck,
  ClipboardPenLine,
  LayoutDashboard,
  Phone,
} from "lucide-react";
import {
  DocumentIconCalculation,
  DocumentIconCertificate,
  DocumentIconConfirmation,
  DocumentIconOffer,
  DocumentIconOrder,
  DocumentIconReport,
  DocumentIconWorkOrder,
} from "@/services/backend/documents/components/document-icon";

export const Overview: NavigationItem = {
  label: t("Übersicht"),
  icon: LayoutDashboard,
  to: "overview",
};

export const Contacts: NavigationItem = {
  label: t("Ansprechpartner"),
  icon: Phone,
  to: "contact",
};

export const Calculations: NavigationItem = {
  label: t("Kalkulationen"),
  icon: DocumentIconCalculation,
  to: "calculations",
};

export const Offers: NavigationItem = {
  label: t("Angebote"),
  icon: DocumentIconOffer,
  to: "offers",
};

export const Orders: NavigationItem = {
  label: t("Auftragseingänge"),
  icon: DocumentIconOrder,
  to: "orders",
};

export const Commitments: NavigationItem = {
  label: t("Sollstellungen"),
  icon: CalendarDays,
  to: "commitments",
};

export const Confirmations: NavigationItem = {
  label: t("Auftragsbestätigungen"),
  icon: DocumentIconConfirmation,
  to: "confirmations",
};

export const WorkOrders: NavigationItem = {
  label: t("Arbeitsscheine"),
  icon: DocumentIconWorkOrder,
  to: "work-orders",
  children: [
    {
      label: t("Planung"),
      icon: CalendarCheck,
      to: "work-orders/planning",
    },
    {
      label: t("Ausführung"),
      icon: ClipboardPenLine,
      to: "work-orders/execution",
    },
    {
      label: t("Nachbereitung"),
      icon: ClipboardCheck,
      to: "work-orders/completion",
    },
  ],
};

export const Certificates: NavigationItem = {
  label: t("Zertifikate"),
  icon: DocumentIconCertificate,
  to: "certificates",
};

// Reports lists the Inspektionsberichte. Their Anlagenberichte are only
// reachable through the Inspektionsbericht summarizing them.
export const Reports: NavigationItem = {
  label: t("Berichte"),
  icon: DocumentIconReport,
  to: "summaries",
};
